var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowheadRight01 = function SvgArrowheadRight01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M0 0h8.554l8.693 10.71.074.089.039-.046 4.277 5.269-4.277 5.27L8.666 32H.111l9.867-12.152 3.065-3.779-.073-.091-3.106-3.824z"
  })));
};
export { SvgArrowheadRight01 as ReactComponent };
export default __webpack_public_path__ + "assets/Arrowhead-Right-01.922ec7c55cdcc152ea3ea3469938c041.svg";